import { Component } from '@angular/core';
import { PaymentStatus } from 'src/common/models/payment/payment-status';
import { PriceType } from 'src/common/models/price/price';
import { UserRole } from 'src/common/models/user/user-role.enum';
import { PageTitleService } from '../../../services/page-title.service';
import { inOutAnimation } from '../../../common/animations';
import { SimpleSolarCalculatorResult } from '../../../common/models/analysis/simple-solar-calculator-result';
import {
  CalculatorColorConfig,
} from '../../../common/components/calculator/calculator-components/simple-calculator/calculator-color-config';

@Component({
  selector: 'psc-calculator-frame-wrapper',
  templateUrl: './calculator-frame-wrapper.component.html',
  animations: [inOutAnimation({})],
})
export class CalculatorFrameWrapperComponent {
  calculationResultWrapper: SimpleSolarCalculatorResult;
  protected readonly UserRole: typeof UserRole = UserRole;

  colorConfig: CalculatorColorConfig = {
    bgColor: 'bg-otp-light-green',
    borderColor: 'border-otp-light-green',
    secondaryButtonType: 'otp-light-green',
    primaryButtonType: 'otp-dark-green',
    textColor: 'text-otp-dark-green',
    borderClass: '!border-otp-light-green',
    afterBorderTopClass: 'after:border-t-otp-light-green',
    accentClass: 'accent-otp-light-green',
    primaryColor: '#006648',
    secondaryColor: '#52ae30',
  };

  constructor(
    private pageTitleService: PageTitleService,
  ) {
    /**
     * t(title.calculator-frame)
     */
    this.pageTitleService.setTitle('title.calculator-frame');
  }

  onCalculationEnded(resultWrapper: SimpleSolarCalculatorResult) {
    this.calculationResultWrapper = resultWrapper;
  }

  startFromBeginning() {
    location.reload();
  }

  protected readonly PaymentStatus = PaymentStatus;
  protected readonly PriceType = PriceType;
}
